import { Component, Prop } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ProjectMixin from '@/_mixins/project'
import LogMixin from '@/_mixins/log'

import EditorViewer from '@/_components/editorJS/viewer/viewer.vue'
import Attachment from '@/_components/image/attachment.vue'
import HSEDocument from '@/views/Project/HSE/models/hseDocument'
import { patchRequest } from '@/plugins/api-axios'
import { getHseDocument } from '../../../../../utils/hse'
@Component({
    components: { EditorViewer, Attachment },
    mixins: [ProjectMixin, LogMixin],
})
export default class Document extends Mixins<MixinInterface>(ProjectMixin, LogMixin) {
    @Prop({ required: true }) id!: string
    @Prop() project!: string

    get document() {
        return this.$store.getters.hseDocument(this.id)
    }

    hseDocument = new HSEDocument(this.document)

    get projectId() {
        return this.project
            ? this.project
            : this.$route.params.type == 'p'
            ? this.$route.params.id
            : this.$route.query.projectId
    }

    get timeZone() {
        return this.projectId
            ? this.$store.getters.project(this.projectId).attributes.timeZone
            : this.guessTimezone()
    }

    get userSetting() {
        return this.document.relationships.userSettings?.data?.id
            ? this.$store.getters.hseDocumentUserSettings(
                  this.document.relationships.userSettings.data.id
              )
            : null
    }

    get read() {
        return this.userSetting ? this.userSetting.attributes.read : true
    }

    get readAt() {
        return this.userSetting ? this.userSetting.attributes.readAt : false
    }

    loadingDocument = false

    archive() {
        this.patchHSEDocument({
            data: {
                id: this.hseDocument._id,
                type: 'hseDocument',
                attributes: {
                    isArchived: true,
                },
            },
            updatedAt: new Date().toUTCString(),
        })
    }

    downloadedAt: any = null
    async downloadDocument(document: any) {
        let url = this.getFile(document.attributes.fileId)
        this.downloadedAt = new Date().toUTCString()
        window.open(url)
        if (!this.read) {
            let params = {
                id: this.userSetting.id,
                type: this.userSetting.type,
                attributes: {
                    read: true,
                },
            }
            await this.patchHSEDocumentUserSettings(params)
        }
    }

    async showDocumentLog(document: any) {
        try {
            this.loadingDocument = true
            const result = await getHseDocument(document._id)
            document.guestDownloadCount = result.data.attributes.guestDownloadCount
            document.uniqueAuthenticatedDownloadCount =
                result.data.attributes.uniqueAuthenticatedDownloadCount
        } catch (e) {
            //
        } finally {
            this.loadingDocument = false
            this.hseDocument.showLog(document)
        }
    }
}
